import classNames from 'classnames';
import React from 'react';

import styles from '../../statics/styles/image-viewer.rtlignore.scss';
import type { ImageClickActionConfig } from './get-image-click-action-config';

export type ViewerImageCaptionProps = {
  imageType: ImageClickActionConfig['type'];
  caption: string | undefined;
  defaultCaption: string;
};

export const ViewerImageCaption = ({
  imageType,
  caption,
  defaultCaption,
}: ViewerImageCaptionProps) => {
  const isLinkImage = imageType === 'link' || imageType === 'anchor';
  const classes = classNames(styles.imageCaption, { [styles.link]: isLinkImage });

  if (!caption || caption === defaultCaption) {
    return null;
  }

  return (
    <figcaption dir="auto" className={classes}>
      {caption}
    </figcaption>
  );
};
